import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, Col, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import UserContext from '../../../layout/UserContext';
import checkPermission from '../../../../components/Authorization/Util';
import OldImageUploader from '../../../../firebase/OldImageUploader';
import { useTranslation } from 'react-i18next';

const General = ({ reportData, form, submit }) => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);
  useEffect(() => {
    if (reportData?.image) {
      setImages([reportData.image]);
    }
  }, [reportData]);

  useEffect(() => {
    form.setFieldsValue({
      image: images,
    });
  }, [images])

  const getDraggerValue = () => {
    const draggerValue = form.getFieldValue('image');
    return draggerValue;
  };

  const { getFieldDecorator } = form;

  const value = useContext(UserContext);
  const disable = !checkPermission(value, 'appcms', 'write');
  return (
    (<div>
      <Row>
        <Col span={13}>
          <Card bordered={false}>
            <Form.Item label={t('appCms.poi.fieldTitle')}>
              {getFieldDecorator('title', {
                rules: [
                  {
                    required: true,
                    message: t('appCms.poi.titleRequired'),
                  },
                ],
                initialValue:
                  reportData && reportData.title && reportData.title
                    ? reportData.title
                    : undefined,
              })(<Input disabled={disable} />)}
            </Form.Item>
            {reportData ? (
              <Form.Item label={t('appCms.poi.beaconLabel')}>
                {getFieldDecorator('beacon', {
                  rules: [],
                  initialValue:
                    reportData &&
                      reportData.beacon &&
                      reportData.beacon.uniqueId
                      ? reportData.beacon.uniqueId
                      : undefined,
                })(<Input disabled={true} />)}
              </Form.Item>
            ) : (
              ''
            )}
          </Card>
        </Col>
        <Col span={11}>
          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('image', {
                valuePropName: 'file',
                rules: [
                  {
                    required: true,
                    message: t('appCms.poiGroup.imageRequired'),
                  },
                ],
              })(
                <Card
                  title={t('appCms.poiGroup.image')}
                  extra={<small>{t('appCms.poiGroup.recommendedDimensions')}</small>}
                >
                  <Row justify="center">
                    <OldImageUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      setFileList={setImages}
                      fileList={images}
                      maxCount={1}
                      storageFolder='poi-group-images'
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>)
  );
};

General.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  reportData: PropTypes.object,
  submit: PropTypes.func,
};

General.contextType = UserContext;

function mapStateToProps() { }

export default connect(mapStateToProps, {})(General);
